import { RecordStore } from '@deqo/foundation';
import { TemplateGroupData } from '../../api/endpoints/templates';
import { AccountModel } from '../account/AccountModel';
import { BoardModel, FolderModel, ModelBroker } from '../dashboard/Models';

const template = {
    workspaceId: '',
    folders: [] as FolderModel[],
};

export class TemplateLibraryModel extends RecordStore(template) {

    public static create(account: AccountModel, broker: ModelBroker, data: TemplateGroupData[]) {

        const { id: workspaceId } = account.workspaces.find(x => x.type === 'library') ?? {};

        // Allocate groups as folders and items as boards
        for (const gp of data) {
            for (const tm of gp.items) {
                broker.allocate(BoardModel, {
                    id: tm.id,
                    workspaceId,
                    folderId: gp.id,
                    label: tm.label,
                    type: 2,
                    thumbUrl: tm.thumbUrl,
                    special: tm.special,
                    pinned: false,
                    createdAt: new Date(1970),
                    updatedAt: new Date(1970),
                });
            }
            broker.allocate(FolderModel, {
                workspaceId,
                id: gp.id,
                label: gp.label,
                icon: gp.icon ?? null,
                // Type is incompatible but as they are are already allocated it should just use id to resolve
                special: gp.special,
                boards: gp.items as any,
                path: `/library/${gp.id}`,
                createdAt: new Date(1970),
                updatedAt: new Date(1970),
            });
        }

        const m = new TemplateLibraryModel();
        m.updateState({
            workspaceId,
            folders: data.map(x => broker.get(FolderModel, x.id)),
        });

        return [m, m.updateState.bind(m) as TemplateLibraryModel['updateState']] as const;
    }
}
